import React, { Fragment } from "react";
import Styles from "./ErrorContainer.module.css";
import errorIcon from "../../assets/images/icons/exclamation.svg";
import successIcon from "../../assets/images/icons/success_icon.svg";
import classNames from "classnames";
function ErrorContainer(props) {

  function renderUi() {
    if (props.type == "style1") {
      return (
        <Fragment>
          <img src={errorIcon} className={Styles.errorIcon} alt="error" />
          <p className={Styles.errorText}>{props.state.error}</p>
        </Fragment>
      );
    } else if(props.type=="style2"){
      return (
        <Fragment>
          <img src={successIcon} className={Styles.errorIcon} style={{marginTop:'2px'}} alt="error" />
          <p className={Styles.successText}>{props.state.message}</p>
        </Fragment>
      );
    }else {
      return <Fragment></Fragment>;
    }
  }
  return (
    <div
      className={classNames(
        Styles.container,
        props.state.error || props.state.message ? Styles.containerActive : ""
      )}
    >
      {renderUi()}
    </div>
  );
}

export default ErrorContainer;
